<template>
  <div class="demo">
    theme-num
    <div>
      <SjPagination
        v-model="currentPage"
        @change="handlePageChange"
        :total="100"
      />
    </div>
    theme-fill
    <div>
      <SjPagination v-model="currentPage" theme="fill" :total="100" />
    </div>
    theme-border
    <div>
      <SjPagination v-model="currentPage" theme="border" :total="100" />
    </div>
    <template v-for="size in ['mini', 'small', 'default', 'middle', 'large']">
      <div :key="`title_${size}`">{{ `size-${size}` }}</div>
      <div :key="size">
        <SjPagination
          v-model="currentPage"
          @change="handlePageChange"
          :size="size"
          theme="fill"
          :total="100"
        />
      </div>
    </template>
    页面数较少时
    <div>
      <SjPagination v-model="currentPage1" :pageSize="50" :total="200" />
    </div>
    修改pager-count
    <div>
      <SjPagination
        v-model="currentPage2"
        :pageSize="20"
        :pager-count="11"
        :total="400"
      />
    </div>
    增加详细信息与调整属性
    <div>
      <SjPagination
        v-model="currentPage3"
        multi
        :pageSize="10"
        :pager-count="5"
        :pageSizes="[10, 20, 50]"
        :total="200"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      currentPage1: 1,
      currentPage2: 1,
      currentPage3: 1
    };
  },
  methods: {
    handlePageChange(val) {
      alert(`change: ${val}`);
    }
  }
};
</script>

<style scoped lang="less">
.demo {
  > * {
    margin-bottom: 10px;
  }
}
</style>
